export default {
  resetDashboardState(state) {
    Object.keys(state).forEach(key => { state[key] = null })
  },
}
